export const environment = {
  production: false,
  nfServiceCode: '04197',
  nfCpfSolicitante: '',

  filesUrl: 'https://s3.sa-east-1.amazonaws.com/files.develop.clina.care',
  homeUrl: 'https://maleta.rocks',
  psUrl: 'https://maleta.rocks',
  dashboardUrl: 'https://maleta.rocks/dashboard',

 restApiMain: 'https://maleta.rocks/api',
 restApi: 'https://maleta.rocks/api/bkf',

  authDomain: 'maleta.auth.us-east-1.amazoncognito.com',

  s3nameFiles: 'https://s3-sa-east-1.amazonaws.com/files.develop.clina.care/',

  cognito: {
    cognitoUserPollId: 'us-east-1_QDa8MbJyO',
    cognitoClientId: '2vub0ahqb0dk42pdhet4h1jvuf',
    authRedirectSignIn: 'https://maleta.rocks',
    authRedirectSignOut: 'https://maleta.rocks',
    authDomain: 'maleta.auth.us-east-1.amazoncognito.com',
    cognitoRegion: 'us-east-1',
  },

  firebase: {
    apiKey: 'AIzaSyAxD8nPsbpHVbDYEmeABE0qoo90eU8V0EY',
    authDomain: 'maleta-rocks.firebaseapp.com',
    projectId: 'maleta-rocks',
    secret: 'k4OFGry3nlBnzBfaCIvTPEh64gF8H0WK',
    storageBucket: 'maleta-rocks.appspot.com',
    messagingSenderId: '915982727125',
    appId: '1:915982727125:web:df05ded2ae0678d9622f5c',
  },
};
